import { api } from '@/services/api';
import {
  FixReferralDepthsResponseDto,
  GetInvalidReferralDepthsDto,
  InvalidReferralDepthsResponseDto,
} from '@repo/common-types';
import { processApiError } from '@repo/utils';

export const fetchInvalidReferralDepthsRest = async (
  params: GetInvalidReferralDepthsDto,
): Promise<InvalidReferralDepthsResponseDto> => {
  try {
    const response = await api.get(`/v1/admin/referrals/depths/invalid`, { params });
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};

export const fixReferralDepthsRest = async (): Promise<FixReferralDepthsResponseDto> => {
  try {
    const response = await api.post(`/v1/admin/referrals/depths/fix`);
    return response.data;
  } catch (error) {
    const userFriendlyMessage = processApiError(error);
    throw new Error(userFriendlyMessage);
  }
};
